import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Loading } from '@shared/components/loading';
import { Text } from '@shared/components/text';
import { useI18n } from '@shared/i18n/useI18n';
import { CHAT_SKELETON, CHAT_SKELETON_BUBBLES, CHAT_SKELETON_KEY } from '../../constants';
import { useChatRetry } from '../../contexts';
import { useDelayedVisible } from '../../hooks/useDelayedVisible';
import { useLoadTimeout } from '../../hooks/useLoadTimeout';
import { ChatLoadingDot } from './ChatLoadingDot';
import { ChatSkeletonBar } from './ChatSkeletonBar';

export const ChatThreadSkeleton = () => {
    const { t } = useI18n();
    const retry = useChatRetry();
    const visible = useDelayedVisible(CHAT_SKELETON.delayMs, CHAT_SKELETON_KEY.thread);
    const timedOut = useLoadTimeout(CHAT_SKELETON.loadTimeoutMs);

    if (timedOut && retry) return <Loading message={t('screens.chat.loadMessagesError')} onRetry={retry} />;

    if (!visible) return <View className="flex-1 bg-white" />;

    return (
        <View className="flex-1 bg-white px-md py-md gap-3 overflow-hidden">
            <View className="flex-row items-center justify-center gap-1.5 mb-1">
                <View className="flex-row items-center gap-1.5">
                    {[0, 1, 2].map(index => (
                        <ChatLoadingDot key={index} index={index} />
                    ))}
                </View>
                <Text className="ml-1 text-sm text-gray-500">{t('screens.chat.loadingMessages')}</Text>
            </View>
            {CHAT_SKELETON_BUBBLES.map((bubble, index) => (
                <ChatSkeletonBar
                    key={index}
                    tint={bubble.mine}
                    style={[
                        styles.bubble,
                        bubble.mine ? styles.alignEnd : styles.alignStart,
                        { width: bubble.width, height: bubble.height },
                    ]}
                />
            ))}
        </View>
    );
};

const styles = StyleSheet.create({
    bubble: { borderRadius: 12 },
    alignStart: { alignSelf: 'flex-start' },
    alignEnd: { alignSelf: 'flex-end' },
});
